import PropTypes from "prop-types";
import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Pdf } from "core/img/imagePath";

const MultiImageUploader = ({
  base64Values = [],
  setBase64Values,
  removeAttachment,
  id = "multi-image-uploader",
}) => {
  const [imagePreviews, setImagePreviews] = useState(base64Values);

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      const newFilesPromises = acceptedFiles.map(
        (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
          })
      );

      Promise.all(newFilesPromises).then((results) => {
        
        const isPdf = results?.[0]?.startsWith("data:application/pdf");

        if (isPdf) {
          setImagePreviews((prev) => [...prev, Pdf]);
        } else {
          setImagePreviews((prev) => [...prev, ...results]);
        }

        setBase64Values(results);
        
      });
    },
    [setBase64Values]
  );

  const removeImage = (index) => {
    setImagePreviews((prev) => prev.filter((_, i) => i !== index));
    removeAttachment(index);
    // setBase64Values((prev) => prev.filter((_, i) => i !== index));
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*",
    multiple: true,
  });

  return (
    <div className="container mt-4" id={id}>
      <div
        {...getRootProps()}
        className="border border-primary border-dashed rounded p-4 text-center cursor-pointer"
        style={{ borderStyle: "dashed", cursor: "pointer" }}
      >
        <input {...getInputProps()} />
        {imagePreviews.length > 0 ? (
          <div className="d-flex flex-wrap gap-3 justify-content-center">
            {imagePreviews.map((img, index) => (
              <div key={index} className="position-relative">
                <img
                  src={img}
                  alt={`Uploaded-${index}`}
                  className="img-fluid rounded shadow"
                  style={{
                    maxWidth: "80px",
                    maxHeight: "80px",
                    objectFit: "contain",
                  }}
                />
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeImage(index);
                  }}
                  type="button"
                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1"
                >
                  ✖
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">Drag & Drop images or Click to Upload</p>
        )}
      </div>
    </div>
  );
};

MultiImageUploader.propTypes = {
  base64Values: PropTypes.array,
  setBase64Values: PropTypes.func,
  removeAttachment: PropTypes.func.isRequired,
  id: PropTypes.string,
};

export default React.memo(MultiImageUploader);
